
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from "react"
import ReactDOM from 'react-dom'
import { Spin, Result } from 'antd'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Loadable from 'react-loadable'
import Main from './main'
import common from '@/common/common.js'

const MyLoadingComponent = () => {
    return <Spin size="large"><div style={{ width: '100%', height: '100%', marginTop: '35%' }}></div></Spin>;
}

const login = Loadable({
    loader: () => import('./login'),
    loading: MyLoadingComponent
});

const closed = Loadable({
    loader: () => import('./result/closed.js'),
    loading: MyLoadingComponent
});

const success = Loadable({
    loader: () => import('./result/success.js'),
    loading: MyLoadingComponent
});

const App = () => {
    if (window.localStorage && (window.localStorage.setItem('a', 123), window.localStorage.getItem('a') == 123)) {
        return (
            // <Router basename={common.BaseName}>
            <Router basename="">
                <Main />
                <Switch>
                    <Route path="/login" component={login} />
                    <Route exact path="/success" component={success} />
                    <Route exact path="/closed" component={closed} />
                </Switch>
            </Router>
        )
    } else {
        return (
            <Result
                status="500"
                title={<div>您的浏览器不支持<a href="https://developer.mozilla.org/zh-CN/docs/Web/API/Window/localStorage#%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7" rel="noopener noreferrer" target="_blank">localStorage</a></div>}
                subTitle="浏览器版本太低。"
                extra={<div>推荐使用 <a href="https://www.google.cn/intl/zh-CN/chrome/" rel="noopener noreferrer" target="_blank">谷歌浏览器</a> 、
                    <a href="http://www.firefox.com.cn/" rel="noopener noreferrer" target="_blank">火狐浏览器</a></div>}
            />
        )
    }
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);